module.exports = __webpack_public_path__ + "img/logo.f1677cc8.png";